module.exports = __webpack_public_path__ + "static/media/slider-1.549b2410.jpg";